import { render, staticRenderFns } from "./CostPerKilometreReport.vue?vue&type=template&id=5bcafd3e&"
import script from "./CostPerKilometreReport.vue?vue&type=script&lang=js&"
export * from "./CostPerKilometreReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports